import React from 'react';
import styles from './CodeBlock.module.css';

/**
 * CodeBlock — muestra código con syntax highlighting manual via dangerouslySetInnerHTML.
 * Recibe el código como string con spans HTML ya coloreados.
 *
 * @param {string} code - HTML string con el código coloreado
 */
function CodeBlock({ code }) {
  return (
    <div className={styles.wrapper}>
      <pre
        className={styles.pre}
        dangerouslySetInnerHTML={{ __html: code }}
      />
    </div>
  );
}

export default CodeBlock;
